
import accordion from './accordion.js'

let $stickyAnchor;
let $stickySection;

function init() {

    $stickyAnchor = $('#stick-here');
    $stickySection = $('#stickThis');

    window.addEventListener('load', function (e) {
        scrollToHash();
    });

    window.addEventListener('hashchange', function (e) {
        scrollToHash();
    });

    var links = document.querySelectorAll('a.product-accordion-jump');
    for (var link of links) {
        link.addEventListener('click', handleJumpLinkClick);
    }

    if ($stickyAnchor.length && $stickySection.length) {

        document.addEventListener('scroll', handleStickyLinkScroll);
        document.addEventListener('DOMContentLoaded', handleStickyLinkScroll);

        var listItems = document.querySelectorAll('ul.anchor-link-list li');
        for (var listItem of listItems) {
            listItem.addEventListener('click', handleStickyLinkClick);
        }

    }

}

function scrollToHash() {

    if (!window.location.hash) {
        return;
    }

    var element = document.querySelector(window.location.hash);
    if (!element) {
        return;
    }

    // open nearest accordion (and populate if document accordion)
    if (element.nextElementSibling) {
        var accordionElement = element.nextElementSibling.classList.contains('accordion-collapse') ? element.nextElementSibling : element.nextElementSibling.querySelector('.accordion-collapse');
        if (accordionElement) {
            var elementTargetCollapse = window.bootstrap.Collapse.getOrCreateInstance(accordionElement);
            if (elementTargetCollapse) {
                accordion.populateDocumentAccordionPanel(element);
                elementTargetCollapse.show();
            }
        }
    }

    // calculate offset - this varies by page layout
    var offset = 0;

    // allow for no offset on pages that require it
    if (!element.dataset || !element.dataset.noOffset) {
        // "stickySection" height takes priority (other pages are offset by header height)
        if ($stickySection.length) {
            offset = $stickySection.outerHeight();
            if (!$stickySection.hasClass('stick')) {
                offset = offset * 2;
            }
        } else {
            offset += $('.header-container.fixed-top').height();
        }
    }

    var scrollTop = element.offsetTop - offset;

    // smooth scroll
    if (scrollTop > 0) {
        $("body,html").animate({
            scrollTop: scrollTop
        }, 800);
    }
}

function handleJumpLinkClick(e) {
    e.preventDefault();
    window.history.pushState(null, null, e.target.hash);
    scrollToHash();
}

function handleStickyLinkClick(e) {
    e.preventDefault();
    window.history.pushState(null, null, e.target.hash);
    scrollToHash();
    $('ul.anchor-link-list li a.hero-jumplink-button').removeClass('active');
    e.target.classList.add('active');
}

function handleStickyLinkScroll(e) {

    var window_top = $(window).scrollTop() + 100;
    var top = $stickyAnchor.offset().top;
    if (window_top > top) {
        $stickySection.addClass('stick');
        $stickyAnchor.height($stickySection.outerHeight() + top);
    } else {
        $stickySection.removeClass('stick');
        $stickyAnchor.height(0);
    }

};

export default {
    init
}